import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { CookieContent } from './Content/CookieContent';
import { ModalCard } from '../ModalCard';
export var CookieBanner = function (_a) {
  var cookies = _a.cookies,
    contentCompact = _a.contentCompact,
    contentDetail = _a.contentDetail,
    hideBackdrop = _a.hideBackdrop,
    onSubmitClick = _a.onSubmitClick;
  var _b = useState('compact'),
    modalView = _b[0],
    toggleModalView = _b[1];
  return _jsx(ModalCard, {
    isVisible: true,
    containerPosition: "bottom",
    hideBackdrop: hideBackdrop,
    children: _jsx(CookieContent, {
      cookies: cookies,
      contentCompact: contentCompact,
      contentDetail: contentDetail,
      onSubmitClick: onSubmitClick,
      toggleView: toggleModalView,
      view: modalView
    })
  });
};